import { Button } from '@mui/material';
import DeleteCustomRuleDrawer, {
  DeleteCustomRuleDrawerData,
} from 'components/drawers/delete-custom-rule-drawer/delete-custom-rule-drawer.component';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import { useTranslation } from 'react-i18next';

type CustomRuleActionsProps = {
  ruleId: string;
};

const CustomRuleActions = ({ ruleId }: CustomRuleActionsProps) => {
  const { t } = useTranslation();
  const { open, toggleWithData, close, drawerData } =
    useUtilityDrawer<DeleteCustomRuleDrawerData>();

  return (
    <>
      <Button color="error" onClick={() => toggleWithData({ ruleId })}>
        {t('page.menus.recommendations.customRules.deleteButton.label')}
      </Button>
      <DeleteCustomRuleDrawer
        open={open}
        close={close}
        drawerData={drawerData}
      />
    </>
  );
};

export default CustomRuleActions;
